import { render, staticRenderFns } from "./expand-sub-table.vue?vue&type=template&id=46995313&scoped=true"
import script from "./expand-sub-table.vue?vue&type=script&lang=js"
export * from "./expand-sub-table.vue?vue&type=script&lang=js"
import style0 from "./expand-sub-table.vue?vue&type=style&index=0&id=46995313&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46995313",
  null
  
)

export default component.exports